import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import "../../../../../../custom.css";

import {
  Link,
  ApiUrl,
  Axios,
  DialogBox,
  Row,
  Col,
  SELECT,
  toast,
  Loading,
  moment,
  DataTablePagination
} from "../../../../../../components";

const { VENUE_BOOKING_HOME } = ApiUrl;

const VenueBookings = (props) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({
    isOpen: false,
    action: null,
    bookingId: null,
  });
  const [rowLoading, setRowLoading] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams({
          limit: rowsPerPage,
          page: page + 1,
          ...(search && { search }),
          ...(status && { status }),
        });
        const response = await Axios.get(`${VENUE_BOOKING_HOME}?${params.toString()}`);
        if (response.data.status) {
          setBookings(response.data.data);
          setTotalCount(response.data.total);
        } else {
          toast.error(response.data.message || "Failed to fetch bookings");
        }
      } catch (error) {
        toast.error("Error fetching venue bookings");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchBookings();
  }, [page, rowsPerPage, search, status]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleStatusChangeFilter = (event) => {
    setStatus(event.target.value);
    setPage(0);
  };

  const formatDateTime = (date, time) => {
    return moment(`${date.split("T")[0]} ${time}`).format("DD-MMMM, hh:mm A");
  };

  const getExtraServices = (booking) => {
    const services = [];
    if (booking.stenography) services.push("Stenography");
    if (booking.transcription) services.push("Transcription");
    if (booking.pantry_service) services.push("Pantry Service");
    if (booking.vide_conference) services.push("Video Conference");
    return services.length > 0 ? services.join(", ") : "None";
  };

  const handleGoBack = () => {
    props.history.goBack();
  };

  const toggleModal = (action = null, bookingId = null) => {
    setModal({
      isOpen: !modal.isOpen,
      action,
      bookingId,
    });
  };

  const handleStatusChange = async () => {
    const { action, bookingId } = modal;
    if (!action || !bookingId) return;

    const payload = {
      status: action === "accept" ? 1 : 0,
    };

    try {
      setRowLoading((prev) => ({ ...prev, [bookingId]: true }));
      const response = await Axios.post(
        `${VENUE_BOOKING_HOME}/${bookingId}/status`,
        payload
      );
      if (response.data.status) {
        setBookings((prevBookings) =>
          prevBookings.map((booking) =>
            booking.id === bookingId ? { ...booking, status: payload.status } : booking
          )
        );
        toast.success(`Booking ${action}ed successfully`);
      } else {
        toast.error(response.data.message || `Failed to ${action} booking`);
      }
    } catch (error) {
      toast.error(`Error ${action}ing booking`);
      console.error(error);
    } finally {
      setRowLoading((prev) => ({ ...prev, [bookingId]: false }));
      toggleModal();
    }
  };

  return (
    <div className="mt-4 mr-4 mb-3">
      <section className="Sales_analytics">
        <div className="venue-admin-booking p-2">

          <Link
            to="#"
            onClick={handleGoBack}
            style={{
              color: "grey",
              fontSize: "32px",
            }}
          >
            <i
              class="zmdi zmdi-arrow-left"
              style={{ fontSize: "22px" }}
            ></i>
          </Link>

          <h2>Venue booking</h2>

          {/* Search and filter */}
          <div className="row m-0">
            <div className="align-items-baseline col-md-8 d-flex w-100 pl-0">
              <div className="position-relative w-100 mt-auto">
                <input
                  type="text"
                  placeholder="search by name, number"
                  className="searchBar pl-4"
                  value={search}
                  onChange={handleSearchChange}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  width="20px"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6 searchbar-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </div>
            </div>
            <div className="col-md-4">
              <select
                value={status}
                onChange={handleStatusChangeFilter}
                className="form-control"
              >
                <option value="">All Status</option>
                <option value="1">Accepted</option>
                <option value="0">Pending</option>
              </select>
            </div>
          </div>

          <div className="table-responsive">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                <Loading />
              </div>
            ) : (
              <table className="venue-admin-table">
                <thead>
                  <tr>
                    <th>Arbitration details</th>
                    <th>Booking details</th>
                    <th>Services extra</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings.length > 0 ? (
                    bookings.map((booking) => (
                      <tr key={booking.id}>
                        <td>
                          <p className="m-0 white-space">
                            Case number:{" "}
                            <span className="font-weight-bold">
                              {booking.case_number}
                            </span>
                          </p>
                          <p className="m-0 white-space">
                            Case name:{" "}
                            <span className="font-weight-bold">
                              {booking.case_name}
                            </span>
                          </p>
                        </td>
                        <td>
                          <p className="m-0 white-space">
                            Venue:{" "}
                            <span className="font-weight-bold">
                              {booking.preferred_venue}
                            </span>
                          </p>
                          <p className="m-0 white-space">
                            Date Time:{" "}
                            <span className="font-weight-bold">
                              {formatDateTime(
                                booking.booking_date,
                                booking.start_time
                              )}
                            </span>
                          </p>
                        </td>
                        <td>{getExtraServices(booking)}</td>
                        <td>{booking.status ? "Accepted" : "Pending"}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            {!booking.status && (
                              <>
                                <button
                                  type="button"
                                  className="venue-booking-table-btn accept-btn"
                                  onClick={() => toggleModal("accept", booking.id)}
                                  disabled={rowLoading[booking.id]}
                                  style={{
                                    opacity: rowLoading[booking.id] ? 0.6 : 1,
                                    transition: "opacity 0.3s ease",
                                  }}
                                >
                                  {rowLoading[booking.id] && modal.action === "accept" && modal.bookingId === booking.id ? (
                                    <span>Loading...</span>
                                  ) : (
                                    "Accept"
                                  )}
                                </button>
                                <button
                                  type="button"
                                  className="venue-booking-table-btn reject-btn"
                                  onClick={() => toggleModal("reject", booking.id)}
                                  disabled={rowLoading[booking.id]}
                                  style={{
                                    opacity: rowLoading[booking.id] ? 0.6 : 1,
                                    transition: "opacity 0.3s ease",
                                  }}
                                >
                                  {rowLoading[booking.id] && modal.action === "reject" && modal.bookingId === booking.id ? (
                                    <span>Loading...</span>
                                  ) : (
                                    "Reject"
                                  )}
                                </button>
                              </>
                            )}

                            <Link
                              to={`/app/admin/venue-bookings-details/${booking.id}`}
                              className="venue-booking-table-btn view-btn d-flex align-items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                width="14px"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="size-6 mr-2"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                />
                              </svg>
                              View
                            </Link>

                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ height: '150px' }}>
                      <td colSpan="5" className="text-center py-3">No bookings found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {bookings.length > 0 && (
              <div className="float-right">
                <DataTablePagination
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  rowsPerPageOptions={[20, 50, 100, 200]}
                />
              </div>
            )}

          </div>
        </div>
      </section>

      <Modal isOpen={modal.isOpen} toggle={toggleModal} centered>
        <div className="modal-top d-flex justify-content-between align-items-center py-1 pt-3 px-3">
          <h5 className="mb-0">
            {typeof modal.action === 'string' && modal.action
              ? `Confirm ${modal.action.charAt(0).toUpperCase() + modal.action.slice(1)}`
              : "Confirm Action"}
          </h5>
          <span onClick={toggleModal} className="modal-cancel12" style={{ cursor: 'pointer' }}>
            <i className="zmdi zmdi-close"></i>
          </span>
        </div>
        <ModalBody>
          <p>
            {typeof modal.action === 'string' && modal.action
              ? `Are you sure you want to ${modal.action} this booking?`
              : "Are you sure you want to perform this action?"}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={toggleModal}
            className="venue-booking-table-btn"
          >
            Cancel
          </Button>
          {typeof modal.action === 'string' && modal.action && (
            <Button
              color={modal.action === "accept" ? "success" : "danger"}
              onClick={handleStatusChange}
              className="venue-booking-table-btn"
            >
              {modal.action.charAt(0).toUpperCase() + modal.action.slice(1)}
            </Button>
          )}
        </ModalFooter>
      </Modal>

    </div>
  );
};

export default VenueBookings;